import { PageHeaderContentProps } from './types';

export const PageHeaderContent = ({ children }: PageHeaderContentProps) => <div className="mx-6">{children}</div>;
